export { paymentLinks_PT_BR } from "./payment-links-pt-br";
export type { paymentLinksTranslations } from "./payment-links-pt-br";
export { paymentLinks_EN_US } from "./payment-links-en-us";
export { paymentLinks_ES_MX } from "./payment-links-es-mx";
export { paymentLinks_ES_ES } from "./payment-links-es-es";
export { paymentLinks_FR_FR } from "./payment-links-fr-fr";
